import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isValidPhoneNumber } from 'libphonenumber-js';

export function validPhoneNumber(): ValidatorFn {
  return (control: AbstractControl) => {
    const phoneNumber: any = control.value;
    if (typeof phoneNumber === 'string' && !isValidPhoneNumber(phoneNumber, 'CH')) {
      return { invalidPhoneNumber: true };
    }
    return null;
  };
}
